<template>
  <base-spinner v-if="!currentFD && !fdError"></base-spinner>
  <div v-if="fdError" class="notification is-danger is-light">
    Failed to load FD data. Please refresh. ({{ fdError }})
  </div>
  <div class="main" v-if="currentFD">
    <h1 class="title align-center is-4">{{ currentFD.date.toDate().toLocaleDateString() }} - {{
      currentFD.sponsor ?
      currentFD.sponsor
      : "Apex"
    }}</h1>

    <FDStatus></FDStatus>

    <div class="tabs is-boxed ">
      <ul>
        <li @click="toggleTab('V')" :class="[selectedTab == 'V' ? 'is-active' : '']">
          <a>
            <span>Volunteers</span>
          </a>
        </li>
        <li @click="toggleTab('S')" :class="[selectedTab == 'S' ? 'is-active' : '']">
          <a>
            <span v-if="currentFD.status == 'DRAFT'">Setup</span>
            <span v-else>Stats</span>
          </a>
        </li>
        <li v-if="currentFD.deliveries_generated" @click="toggleTab('D')"
          :class="[selectedTab == 'D' ? 'is-active' : '']">
          <a>
            <span>Deliveries</span>
          </a>
        </li>
        <li v-if="currentFD.deliveries_generated" @click="toggleTab('SC')"
          :class="[selectedTab == 'SC' ? 'is-active' : '']">
          <a>
            <span>Self Collection</span>
          </a>
        </li>
      </ul>
    </div>
        <div v-if="selectedTab == 'V'">
            <div class="box has-background-info-light">
                <VolunteerSignUpStats></VolunteerSignUpStats>
            </div>
        <div class="box has-background-info-light" v-if="!currentFD.teams_driving">
            <ViewVolunteers :fdID="currentFD.id"></ViewVolunteers>
        </div>
        <div class="box has-background-info-light">
            <CreateTeams></CreateTeams>
            <div v-if="currentFD.teams_driving">
                <TeamAssignment :fdID="currentFD.id" :drivingTeams="currentFD.teams_driving"
                    :walkingTeams="currentFD.teams_walking">
                </TeamAssignment>
            </div>
        </div>
    </div>
    <div v-else-if="selectedTab == 'S'">
      <div v-if="currentFD.status == 'DRAFT'" class="block">
        <GenerateDeliveries></GenerateDeliveries>
      </div>
      <div v-if="currentFD.deliveries_generated">
        <AssignDeliveriesToTeams></AssignDeliveriesToTeams>
        <FDStatistics></FDStatistics>
        <div v-if="currentFD.status != 'DRAFT'">
          <NotDeliveredDeliveries :fdID="currentFD.id" :fdStatus="currentFD.status"></NotDeliveredDeliveries>
          <PendingDeliveries :fdID="currentFD.id" :fdStatus="currentFD.status"></PendingDeliveries>
        </div>
      </div>
    </div>
    <div v-else-if="selectedTab == 'D'">
      <AssignDeliveriesToTeams></AssignDeliveriesToTeams>
      <AllDeliveries :fdID="currentFD.id" :fdStatus="currentFD.status" :drivingTeams="currentFD.teams_driving"
        :walkingTeams="currentFD.teams_walking"></AllDeliveries>
    </div>
    <div v-else>
      <SelfCollectionAttendance></SelfCollectionAttendance>
      <SelfCollections :fdID="currentFD.id" :fdStatus="currentFD.status" :drivingTeams="currentFD.teams_driving"
        :walkingTeams="currentFD.teams_walking"></SelfCollections>
    </div>
  </div>
</template>

<script>
import PendingDeliveries from '@/components/delivery/PendingDeliveries.vue';
import NotDeliveredDeliveries from '@/components/delivery/NotDeliveredDeliveries.vue';
import FDStatus from '@/components/fd/FDStatus.vue';
import GenerateDeliveries from '@/components/fd/GenerateDeliveries.vue'
import FDStatistics from '@/components/fd/FDStatistics.vue';
import CreateTeams from '@/components/fd/CreateTeams.vue';
import VolunteerSignUpStats from '@/components/volunteer/VolunteerSignUpStats.vue';
import ViewVolunteers from '@/components/volunteer/ViewVolunteers.vue';
import TeamAssignment from '@/components/volunteer/TeamAssignment.vue';
import AssignDeliveriesToTeams from '@/components/delivery/AssignDeliveriesToTeams.vue';
import AllDeliveries from '@/components/delivery/AllDeliveries.vue';
import SelfCollectionAttendance from '@/components/delivery/SelfCollectionAttendance.vue';
import SelfCollections from '@/components/delivery/SelfCollections.vue';

export default {
  components: {
    PendingDeliveries,
    NotDeliveredDeliveries,
    FDStatus,
    GenerateDeliveries,
    FDStatistics,
    CreateTeams,
    VolunteerSignUpStats,
    ViewVolunteers,
    TeamAssignment,
    AssignDeliveriesToTeams,
    AllDeliveries,
    SelfCollectionAttendance,
    SelfCollections
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedTab: 'V'
    }
  },
  created() {
    this.listenFDbyID();
  },
  methods: {
    listenFDbyID() {
      this.$store.dispatch('fd/listenFDbyID', this.id);
    },
    toggleTab(to) {
      if (to != this.selectedTab) {
        this.selectedTab = to;
      }
    }
  },
  computed: {
    currentFD() {
      return this.$store.getters['fd/getCurrentFD'];
    },
    fdError() {
      return this.$store.getters['fd/getFDError'];
    }
  },
  unmounted() {
    this.$store.dispatch('fd/unsubscribeFD');
    this.$store.dispatch('delivery/unsubDeliveries');
  }
}

</script>